import { InjectionToken } from '@angular/core';

/**
 * Indirection over the global `window` so navigation side effects stay mockable. jsdom seals
 * `location` and its members, so code calling `window.location` directly cannot be tested.
 */
export const WINDOW_TOKEN = new InjectionToken<Window>('WINDOW_TOKEN', {
    factory: () => window,
});
